/******/ (() => { // webpackBootstrap
/******/  var __webpack_modules__ = ({


/***/ "./src/app.ts":
/*!********************!*\
 !*** ./src/app.ts ***!
 \********************/
/***/ (function () {


				function _typeof(o) {
					"@babel/helpers - typeof";


					return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
						return typeof o;
					} : function (o) {
						return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
					}, _typeof(o);
				}
				function _regeneratorRuntime() {
					"use strict";


					/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
					_regeneratorRuntime = function _regeneratorRuntime() {
						return e;
					};
					var t,
						e = {},
						r = Object.prototype,
						n = r.hasOwnProperty,
						o = Object.defineProperty || function (t, e, r) {
							t[e] = r.value;
						},
						i = "function" == typeof Symbol ? Symbol : {},
						a = i.iterator || "@@iterator",
						c = i.asyncIterator || "@@asyncIterator",
						u = i.toStringTag || "@@toStringTag";
					function define(t, e, r) {
						return Object.defineProperty(t, e, {
							value: r,
							enumerable: !0,
							configurable: !0,
							writable: !0
						}), t[e];
					}
					try {
						define({}, "");
					} catch (t) {
						define = function define(t, e, r) {
							return t[e] = r;
						};
					}
					function wrap(t, e, r, n) {
						var i = e && e.prototype instanceof Generator ? e : Generator,
							a = Object.create(i.prototype),
							c = new Context(n || []);
						return o(a, "_invoke", {
							value: makeInvokeMethod(t, r, c)
						}), a;
					}
					function tryCatch(t, e, r) {
						try {
							return {
								type: "normal",
								arg: t.call(e, r)
							};
						} catch (t) {
							return {
								type: "throw",
								arg: t
							};
						}
					}
					e.wrap = wrap;
					var h = "suspendedStart",
						l = "suspendedYield",
						f = "executing",
						s = "completed",
						y = {};
					function Generator() { }
					function GeneratorFunction() { }
					function GeneratorFunctionPrototype() { }
					var p = {};
					define(p, a, function () {
						return this;
					});
					var d = Object.getPrototypeOf,
						v = d && d(d(values([])));
					v && v !== r && n.call(v, a) && (p = v);
					var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
					function defineIteratorMethods(t) {
						["next", "throw", "return"].forEach(function (e) {
							define(t, e, function (t) {
								return this._invoke(e, t);
							});
						});
					}
					function AsyncIterator(t, e) {
						function invoke(r, o, i, a) {
							var c = tryCatch(t[r], t, o);
							if ("throw" !== c.type) {
								var u = c.arg,
									h = u.value;
								return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
									invoke("next", t, i, a);
								}, function (t) {
									invoke("throw", t, i, a);
								}) : e.resolve(h).then(function (t) {
									u.value = t, i(u);
								}, function (t) {
									return invoke("throw", t, i, a);
								});
							}
							a(c.arg);
						}
						var r;
						o(this, "_invoke", {
							value: function value(t, n) {
								function callInvokeWithMethodAndArg() {
									return new e(function (e, r) {
										invoke(t, n, e, r);
									});
								}
								return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
							}
						});
					}
					function makeInvokeMethod(e, r, n) {
						var o = h;
						return function (i, a) {
							if (o === f) throw new Error("Generator is already running");
							if (o === s) {
								if ("throw" === i) throw a;
								return {
									value: t,
									done: !0
								};
							}
							for (n.method = i, n.arg = a; ;) {
								var c = n.delegate;
								if (c) {
									var u = maybeInvokeDelegate(c, n);
									if (u) {
										if (u === y) continue;
										return u;
									}
								}
								if ("next" === n.method) n.sent = n._sent = n.arg; else if ("throw" === n.method) {
									if (o === h) throw o = s, n.arg;
									n.dispatchException(n.arg);
								} else "return" === n.method && n.abrupt("return", n.arg);
								o = f;
								var p = tryCatch(e, r, n);
								if ("normal" === p.type) {
									if (o = n.done ? s : l, p.arg === y) continue;
									return {
										value: p.arg,
										done: n.done
									};
								}
								"throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
							}
						};
					}
					function maybeInvokeDelegate(e, r) {
						var n = r.method,
							o = e.iterator[n];
						if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
						var i = tryCatch(o, e.iterator, r.arg);
						if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
						var a = i.arg;
						return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
					}
					function pushTryEntry(t) {
						var e = {
							tryLoc: t[0]
						};
						1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
					}
					function resetTryEntry(t) {
						var e = t.completion || {};
						e.type = "normal", delete e.arg, t.completion = e;
					}
					function Context(t) {
						this.tryEntries = [{
							tryLoc: "root"
						}], t.forEach(pushTryEntry, this), this.reset(!0);
					}
					function values(e) {
						if (e || "" === e) {
							var r = e[a];
							if (r) return r.call(e);
							if ("function" == typeof e.next) return e;
							if (!isNaN(e.length)) {
								var o = -1,
									i = function next() {
										for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
										return next.value = t, next.done = !0, next;
									};
								return i.next = i;
							}
						}
						throw new TypeError(_typeof(e) + " is not iterable");
					}
					return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
						value: GeneratorFunctionPrototype,
						configurable: !0
					}), o(GeneratorFunctionPrototype, "constructor", {
						value: GeneratorFunction,
						configurable: !0
					}), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
						var e = "function" == typeof t && t.constructor;
						return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
					}, e.mark = function (t) {
						return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
					}, e.awrap = function (t) {
						return {
							__await: t
						};
					}, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
						return this;
					}), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
						void 0 === i && (i = Promise);
						var a = new AsyncIterator(wrap(t, r, n, o), i);
						return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
							return t.done ? t.value : a.next();
						});
					}, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
						return this;
					}), define(g, "toString", function () {
						return "[object Generator]";
					}), e.keys = function (t) {
						var e = Object(t),
							r = [];
						for (var n in e) r.push(n);
						return r.reverse(), function next() {
							for (; r.length;) {
								var t = r.pop();
								if (t in e) return next.value = t, next.done = !1, next;
							}
							return next.done = !0, next;
						};
					}, e.values = values, Context.prototype = {
						constructor: Context,
						reset: function reset(e) {
							if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
						},
						stop: function stop() {
							this.done = !0;
							var t = this.tryEntries[0].completion;
							if ("throw" === t.type) throw t.arg;
							return this.rval;
						},
						dispatchException: function dispatchException(e) {
							if (this.done) throw e;
							var r = this;
							function handle(n, o) {
								return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
							}
							for (var o = this.tryEntries.length - 1; o >= 0; --o) {
								var i = this.tryEntries[o],
									a = i.completion;
								if ("root" === i.tryLoc) return handle("end");
								if (i.tryLoc <= this.prev) {
									var c = n.call(i, "catchLoc"),
										u = n.call(i, "finallyLoc");
									if (c && u) {
										if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
										if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
									} else if (c) {
										if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
									} else {
										if (!u) throw new Error("try statement without catch or finally");
										if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
									}
								}
							}
						},
						abrupt: function abrupt(t, e) {
							for (var r = this.tryEntries.length - 1; r >= 0; --r) {
								var o = this.tryEntries[r];
								if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
									var i = o;
									break;
								}
							}
							i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
							var a = i ? i.completion : {};
							return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
						},
						complete: function complete(t, e) {
							if ("throw" === t.type) throw t.arg;
							return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
						},
						finish: function finish(t) {
							for (var e = this.tryEntries.length - 1; e >= 0; --e) {
								var r = this.tryEntries[e];
								if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
							}
						},
						"catch": function _catch(t) {
							for (var e = this.tryEntries.length - 1; e >= 0; --e) {
								var r = this.tryEntries[e];
								if (r.tryLoc === t) {
									var n = r.completion;
									if ("throw" === n.type) {
										var o = n.arg;
										resetTryEntry(r);
									}
									return o;
								}
							}
							throw new Error("illegal catch attempt");
						},
						delegateYield: function delegateYield(e, r, n) {
							return this.delegate = {
								iterator: values(e),
								resultName: r,
								nextLoc: n
							}, "next" === this.method && (this.arg = t), y;
						}
					}, e;
				}
				function _classCallCheck(instance, Constructor) {
					if (!(instance instanceof Constructor)) {
						throw new TypeError("Cannot call a class as a function");
					}
				}
				function _defineProperties(target, props) {
					for (var i = 0; i < props.length; i++) {
						var descriptor = props[i];
						descriptor.enumerable = descriptor.enumerable || false;
						descriptor.configurable = true;
						if ("value" in descriptor) descriptor.writable = true;
						Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
					}
				}
				function _createClass(Constructor, protoProps, staticProps) {
					if (protoProps) _defineProperties(Constructor.prototype, protoProps);
					if (staticProps) _defineProperties(Constructor, staticProps);
					Object.defineProperty(Constructor, "prototype", {
						writable: false
					});
					return Constructor;
				}
				function _toPropertyKey(t) {
					var i = _toPrimitive(t, "string");
					return "symbol" == _typeof(i) ? i : String(i);
				}
				function _toPrimitive(t, r) {
					if ("object" != _typeof(t) || !t) return t;
					var e = t[Symbol.toPrimitive];
					if (void 0 !== e) {
						var i = e.call(t, r || "default");
						if ("object" != _typeof(i)) return i;
						throw new TypeError("@@toPrimitive must return a primitive value.");
					}
					return ("string" === r ? String : Number)(t);
				}
				var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
					function adopt(value) {
						return value instanceof P ? value : new P(function (resolve) {
							resolve(value);
						});
					}
					return new (P || (P = Promise))(function (resolve, reject) {
						function fulfilled(value) {
							try {
								step(generator.next(value));
							} catch (e) {
								reject(e);
							}
						}
						function rejected(value) {
							try {
								step(generator["throw"](value));
							} catch (e) {
								reject(e);
							}
						}
						function step(result) {
							result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
						}
						step((generator = generator.apply(thisArg, _arguments || [])).next());
					});
				};
				var EditionConsent = /*#__PURE__*/function () {
					function EditionConsent() {
						var _this = this;
						_classCallCheck(this, EditionConsent);
						// declare dataLayer
						this.dataLayer = window.dataLayer || [];
						// Event listener for visitor consent collection - built in Shopify event for visitor consent
						document.addEventListener("visitorConsentCollected", function () {
							return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
								var state, visitorConsent;
								return _regeneratorRuntime().wrap(function _callee$(_context) {
									while (1) switch (_context.prev = _context.next) {
										case 0:
											state = "update";
											_context.next = 3;
											return window.Shopify.customerPrivacy.currentVisitorConsent();
										case 3:
											visitorConsent = _context.sent;
											console.log(visitorConsent, state);
											this.consentSettings(visitorConsent, state);
										case 6:
										case "end":
											return _context.stop();
									}
								}, _callee, this);
							}));
						});
						this.updateConsent();
					}
					// methods
					// method to push data to the dataLayer
					// method to update consent settings based on visitorconsent and state
					// method to fire gtag method with the consent settings from updateConsent method
					_createClass(EditionConsent, [{
						key: "gtag",
						value: function gtag() {
							for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
								args[_key] = arguments[_key];
							}
							this.dataLayer.push(arguments);
						}
					}, {
						key: "updateConsent",
						value: function updateConsent() {
							var _this2 = this;
							setTimeout(function () {
								if (window.Shopify.customerPrivacy === undefined) return;
								var state = "update";
								var visitorConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
								console.log(visitorConsent, state);
								_this2.consentSettings(visitorConsent, state);
							}, 100);
						}
					}, {
						key: "consentSettings",
						value: function consentSettings(visitorConsent, state) {
							var consent = {
								functionality_storage: visitorConsent.preferences === "yes" ? "granted" : "granted",
								analytics_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
								personalization_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
								ad_storage: visitorConsent.marketing === "yes" ? "granted" : "denied",
								ad_user_data: visitorConsent.marketing === "yes" ? "granted" : "denied",
								ad_personalization: visitorConsent.marketing === "yes" ? "granted" : "denied",
								wait_for_update: 500
							};
							this.gtag("consent", state, consent);
							// set local Storage for consent settings for further use on other pages or after page refresh
							localStorage.setItem("consentSettings", JSON.stringify(consent));
						}
					}]);
					return EditionConsent;
				}();
				var editionConsent = new EditionConsent();


				/***/
			}),


/***/ "./src/app.js":
/*!********************!*\
!*** ./src/app.js ***!
\********************/
/***/ (() => {






				/***/
			}),


/***/ "./src/app.scss":
/*!**********************!*\
!*** ./src/app.scss ***!
\**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


				"use strict";
				__webpack_require__.r(__webpack_exports__);
				// extracted by mini-css-extract-plugin




				/***/
			})


		/******/
	});
/************************************************************************/
/******/  // The module cache
/******/  var __webpack_module_cache__ = {};
/******/
/******/  // The require function
/******/  function __webpack_require__(moduleId) {
/******/    // Check if module is in cache
/******/    var cachedModule = __webpack_module_cache__[moduleId];
/******/    if (cachedModule !== undefined) {
/******/      return cachedModule.exports;
			/******/
		}
/******/    // Create a new module (and put it into the cache)
/******/    var module = __webpack_module_cache__[moduleId] = {
/******/      // no module.id needed
/******/      // no module.loaded needed
/******/      exports: {}
			/******/
		};
/******/
/******/    // Execute the module function
/******/    __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/    // Return the exports of the module
/******/    return module.exports;
		/******/
	}
/******/
/******/  // expose the modules object (__webpack_modules__)
/******/  __webpack_require__.m = __webpack_modules__;
/******/
/************************************************************************/
/******/  /* webpack/runtime/chunk loaded */
/******/  (() => {
/******/    var deferred = [];
/******/    __webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/      if (chunkIds) {
/******/        priority = priority || 0;
/******/        for (var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/        deferred[i] = [chunkIds, fn, priority];
/******/        return;
				/******/
			}
/******/      var notFulfilled = Infinity;
/******/      for (var i = 0; i < deferred.length; i++) {
/******/        var [chunkIds, fn, priority] = deferred[i];
/******/        var fulfilled = true;
/******/        for (var j = 0; j < chunkIds.length; j++) {
/******/          if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/            chunkIds.splice(j--, 1);
						/******/
					} else {
/******/            fulfilled = false;
/******/            if (priority < notFulfilled) notFulfilled = priority;
						/******/
					}
					/******/
				}
/******/        if (fulfilled) {
/******/          deferred.splice(i--, 1)
/******/          var r = fn();
/******/          if (r !== undefined) result = r;
					/******/
				}
				/******/
			}
/******/      return result;
			/******/
		};
		/******/
	})();
/******/
/******/  /* webpack/runtime/hasOwnProperty shorthand */
/******/  (() => {
/******/    __webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
		/******/
	})();
/******/
/******/  /* webpack/runtime/make namespace object */
/******/  (() => {
/******/    // define __esModule on exports
/******/    __webpack_require__.r = (exports) => {
/******/      if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/        Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
				/******/
			}
/******/      Object.defineProperty(exports, '__esModule', { value: true });
			/******/
		};
		/******/
	})();
/******/
/******/  /* webpack/runtime/jsonp chunk loading */
/******/  (() => {
/******/    // no baseURI
/******/
/******/    // object to store loaded and loading chunks
/******/    // undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/    // [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/    var installedChunks = {
/******/      "/assets/app": 0,
/******/      "assets/app": 0
			/******/
		};
/******/
/******/    // no chunk on demand loading
/******/
/******/    // no prefetching
/******/
/******/    // no preloaded
/******/
/******/    // no HMR
/******/
/******/    // no HMR manifest
/******/
/******/    __webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/
/******/    // install a JSONP callback for chunk loading
/******/    var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/      var [chunkIds, moreModules, runtime] = data;
/******/      // add "moreModules" to the modules object,
/******/      // then flag all "chunkIds" as loaded and fire callback
/******/      var moduleId, chunkId, i = 0;
/******/      if (chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/        for (moduleId in moreModules) {
/******/          if (__webpack_require__.o(moreModules, moduleId)) {
/******/            __webpack_require__.m[moduleId] = moreModules[moduleId];
						/******/
					}
					/******/
				}
/******/        if (runtime) var result = runtime(__webpack_require__);
				/******/
			}
/******/      if (parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/      for (; i < chunkIds.length; i++) {
/******/        chunkId = chunkIds[i];
/******/        if (__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/          installedChunks[chunkId][0]();
					/******/
				}
/******/        installedChunks[chunkId] = 0;
				/******/
			}
/******/      return __webpack_require__.O(result);
			/******/
		}
/******/
/******/    var chunkLoadingGlobal = self["webpackChunkcookiecompliance"] = self["webpackChunkcookiecompliance"] || [];
/******/    chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/    chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
		/******/
	})();
/******/
/************************************************************************/
/******/
/******/  // startup
/******/  // Load entry module and return exports
/******/  // This entry module depends on other loaded chunks and execution need to be delayed
/******/  __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.js")))
/******/  __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.ts")))
/******/  var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.scss")))
/******/  __webpack_exports__ = __webpack_require__.O(__webpack_exports__);
	/******/
	/******/
})()
	;



